<!-- mpanel.vue -->
<template>
    <transition name="fade">
        <div class="modal-box">
            <div class="modal-content">
                <!--头部-->
                <div class="modal-header">
                    <p class="title">验证码验证</p>
                    <a @click="onCancel"
                       class="modal-close"
                       href="javascript:void(0)">
                      <a-icon type="close" :style="{ fontSize: '30px' }" />
                    </a>
                </div>
                <!--内容区域-->
                <div class="modal-body">
                    <div id="mpanel"
                         ref="mpanel">
                    </div>
                  <div id="check-btn" class="verify-btn" v-show="mpaneltype">确定</div>
                </div>
                <!--尾部,操作按钮  -->
                <!-- <div class="modal-footer">
                </div> -->
            </div>
        </div>
    </transition>

</template>

<script>
import {IMG_URL} from "@/config";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
    name: 'Mpanel',
    data() {
        return {
            path: null,
          mpaneltype:false
        }
    },
    mounted() {
        this.initMpanel();
    },
    methods: {
        onCancel() {
            this.$emit('close');
        },
        // 提示框
        showToolTip(text) {
            // this.$vux.toast.text(text);
          console.log(text)
        },
        // 验证
        initMpanel() {
            // this.codeVerify()  //运算验证码
             this.slideVerify()  //拼图验证码
          //this.pointsVerify()  //拼字验证码
        },
        // 运算验证码
        codeVerify() {           // https://veui.net/document/index
            this.mpaneltype = true;
            let _this = this
          // eslint-disable-next-line no-undef
            $('#mpanel').codeVerify({
                type: 2,
                figure: 100,
                arith: 0,
                width: '100%',
                height: '50px',
                fontSize: '30px',
                btnId: 'check-btn',
                ready: function () {
                },
                success: function () {
                    _this.showToolTip("验证成功！")
                    // 向父组件传值
                    _this.$emit('success');
                },
                error: function () {
                    _this.showToolTip("验证码不匹配！")
                }
            });
        },
        // 拼图验证码
        slideVerify() {           // https://veui.net/document/index
            let _this = this
          // eslint-disable-next-line no-undef
            $('#mpanel').slideVerify({
                type: 2,
                mode: 'pop',
                vOffset: 5,
                vSpace: 5,
                explain: '向右滑动完成验证',
              imgUrl: IMG_URL,
              imgName: ['verify.jpg'],
                imgSize: {
                    width: '100%',
                    height: '200px',
                },
                blockSize: {
                    width: '40px',
                    height: '40px',
                },
                barSize: {
                    width: '100%',
                    height: '40px',
                },
                ready: function () {
                },
                success: function () {
                    _this.showToolTip("验证成功！")
                    // 向父组件传值
                    _this.$emit('success');
                },
                error: function () {
                    _this.showToolTip("验证码不匹配！")
                }
            });
        },
        // 拼字验证码
        pointsVerify() {           // https://veui.net/document/index
            let _this = this
          // eslint-disable-next-line no-undef
            $('#mpanel').pointsVerify({
                mode: 'pop',
                defaultNum: 4,
                checkNum: 2,
                vSpace: 5,
              imgUrl: IMG_URL,
              imgName: ['verify.jpg'],
                imgSize: {
                    width: '100%',
                    height: '200px',
                },
                barSize: {
                    width: '100%',
                    height: '40px',
                },
                ready: function () {
                },
                success: function () {
                    _this.showToolTip("验证成功！")
                    // 向父组件传值
                    _this.$emit('success');
                },
                error: function () {
                    _this.showToolTip("验证码不匹配！")
                }
            });
        }
    }
}
</script>
<style scoped>
@import url('../assets/verify.css');
.modal-box {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.modal-content {
  position: relative;
  width: 300px;
  /* background: #fff; */
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 13px;
}
.modal-header {
  text-align: center;
  border: 0;
}
.modal-header .title {
  font-size: 20px;
  font-weight: 550;
}
.modal-body{
    margin-top: -25px;
}
.modal-close {
  position: absolute;
  right: -10px;
  top: -15px;
  color: #999494;
  font-size: 14px;
}

.fade-enter-active {
  animation: fade-in 0.5s;
}
.fade-leave-active {
  animation: fade-in 0.5s reverse;
}
@keyframes fade-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>